import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'companyPlural',
  pure: false,
  standalone: false,
})
export class CompanyPluralPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  private currentLang: string;
  private sub: Subscription;

  constructor() {
    this.currentLang = this.translate.currentLang || this.translate.defaultLang;

    this.sub = this.translate.onLangChange.subscribe(({ lang }) => {
      this.currentLang = lang;
    });
  }

  transform(count: number): string {
    if (this.currentLang !== 'pl') {
      return this.translate.instant('MANAGER.COMPANIES');
    }

    if (count === 1) {
      return 'firmę';
    }

    const mod10 = count % 10;
    const mod100 = count % 100;

    const isTeens = mod100 >= 11 && mod100 <= 14;
    const endsWith2to4 = mod10 >= 2 && mod10 <= 4;

    if (!isTeens && endsWith2to4) {
      return 'firmy';
    }

    return 'firm';
  }
}
